export const TagColor = {
  Undefined: "none",
  Red: "red",
  Pink: "pink",
  Purple: "purple",
  Blue: "blue",
  Cyan: "cyan",
  Green: "green",
  Yellow: "yellow",
  Gray: "gray",
} as const
export type TagColor = (typeof TagColor)[keyof typeof TagColor]
